import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../../../../shared/shared.module'
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';

import { AgGridModule } from 'ag-grid-angular';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { AnnualComplianceAdminReportComponent } from './admin/annual-compliance-admin-report/annual-compliance-admin-report.component';
import { AnnualAuditModule } from './member/annual-audit-member.module';




@NgModule({
  declarations: [
    
    AnnualComplianceAdminReportComponent


  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    AnnualAuditModule,
    HighchartsChartModule
  ]
})
export class AnnualAuditAdminModule { }
